import createEnum from 'scripts/lib/create_enum';

export default createEnum(
  'ADD',
  'BLIND_TRANSFER',
  'CANCEL_WARM_TRANSFER',
  'COMPLETE_WARM_TRANSFER',
  'END_CALL',
  'END_CONFERENCE',
  'HOLD',
  'INITIATE_WARM_TRANSFER',
  'MUTE',
  'PAUSE_RECORDING',
  'RECORD_QUALITY_EVENT',
  'REMOVE',
  'RESUME_RECORDING'
);



// WEBPACK FOOTER //
// ./src/scripts/domain/models/phone_controls_actions.js